import { render, staticRenderFns } from "./semicircle_guage_component.vue?vue&type=template&id=2bcbe8b3&"
import script from "./semicircle_guage_component.vue?vue&type=script&lang=js&"
export * from "./semicircle_guage_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports